import React, { useEffect, useState } from "react";
import DynamicTable from "@atlaskit/dynamic-table";
import { useSelector, useDispatch } from "react-redux";
import { Status } from "@atlaskit/status";
import uuid from "react-uuid";
import { Link } from "react-router-dom";
import { formatDate } from "../common/utils/formatter";
import { getFlow, getActionName } from "../common/utils/integration.util";
import Button from "@atlaskit/button/new";
import DeleteIcon from "@atlaskit/icon/core/delete";
import { deleteNotification } from "../redux/actions/notificationActions";
import ConfirmModal, { ACTION_DELETE, ACTION_DISCARD } from "../common/components/ConfirmModal";

const NotificationPage = () => {
  const dispatch = useDispatch();

  const items = useSelector((state) => state.notification.items);
  const flows = useSelector((state) => state.integration.flows);

  const [open, setOpen] = useState(false);
  const [action, setAction] = useState("none");
  const [targetId, setTargetId] = useState("");
  const [targetName, setTargetName] = useState("");

  useEffect(() => {}, [items]);

  const head = {
    cells: [
      {
        key: "date",
        content: "Created",
        isSortable: true,
        width: 10,
      },
      {
        key: "type",
        content: "Type",
        isSortable: true,
        width: 10,
      },
      {
        key: "message",
        content: "Message",
        shouldTruncate: true,
        isSortable: true,
        width: 25,
      },
      {
        key: "resource",
        content: "Resource",
        isSortable: true,
        width: 10,
      },
      {
        key: "action",
        content: "Action",
        width: 10,
      },
    ],
  };
  const getTypeColor = (type) => {
    switch (type) {
      case "ERROR":
        return "red";
      case "INFO":
        return "green";
      case "AUDIT":
        return "blue";
      case "WARNING":
        return "yellow";
      default:
        break;
    }
  };
  const deleteConfirm = (notificationId, message) => {
    setTargetId(notificationId);
    setTargetName(message);

    setAction(ACTION_DELETE);
    setOpen(true);
  };

  const onAction = () => {
    if (action === ACTION_DELETE) {
      dispatch(deleteNotification(targetId));
    } else if (action === ACTION_DISCARD) {
      onClose();
    }

    setOpen(false);
    setAction("none");
  };

  const onClose = () => {
    setOpen(false);
    setAction("none");
  };
  //console.log(items);
  let rows = [];
  if (items) {
    rows = items.map((item) => {
      const flow = getFlow(item?.metadata?.flowId, flows);
      const actionName = getActionName(item?.metadata?.actionId, flow);

      return {
        key: `row-${item.id}`,
        cells: [
          {
            key: uuid(),
            content: formatDate(item.created),
          },
          {
            key: uuid(),
            content: <Status text={item.type} color={getTypeColor(item.type)} />,
          },
          {
            key: uuid(),
            content: item.message,
          },
          {
            key: uuid(),
            content: <Link to={`/integration/${item?.metadata?.flowId}/action/${item?.metadata?.actionId}`}>{actionName}</Link>,
          },
          {
            key: uuid(),
            content: <Button iconBefore={DeleteIcon} onClick={() => deleteConfirm(item.id, item.message)}></Button>,
          },
        ],
      };
    });
  }

  return (
    <div className="ihub-main-view">
      <h3>Notifications</h3>
      Table will show any system notification, such as rate limits.
      <DynamicTable head={head} rows={rows} de rowsPerPage={100} defaultPage={1} loadingSpinnerSize="large" isRankable />
      <ConfirmModal action={action} targetName={targetName} targetId={targetId} isOpen={open} onAction={onAction} onClose={onClose} />
    </div>
  );
};
export default NotificationPage;
